import {EmployeeVI} from "./employee/vi";
import {EmployeeContractVI} from "./contract/vi";
import {EmployeeFineVI} from "./fine/vi";
import {EmployeeRewardWelfareVI} from "./reward-welfare/vi";

export const RecordVI = {
    ...EmployeeVI,
    ...EmployeeContractVI,
    ...EmployeeFineVI,
    ...EmployeeRewardWelfareVI
}